import { Role } from "@cryptors/api-client";
import { Box, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

import { useGetCurrentUser } from "@/api/users.api";
import CryptorsLogo from "@/assets/svg/CryptorsLogo.svg?react";
import { getCurrentRole } from "@/providers/authProvider";

type TitleProps = {
  collapsed: boolean;
};

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const { palette } = useTheme();
  const isClient = getCurrentRole() === Role.CLIENT;
  const { data: currentUser } = useGetCurrentUser(isClient);
  const logoUrl = isClient ? currentUser?.logoUrl : null;
  const brandingSize = logoUrl
    ? collapsed
      ? "collapsed"
      : "expanded"
    : undefined;
  const titleHeight = brandingSize === "expanded" ? "144px" : "112px";

  return (
    <Link to="/">
      <Box
        sx={{
          boxSizing: "border-box",
          height: brandingSize ? titleHeight : "64px",
          width: collapsed ? "56px" : "170px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: logoUrl ? (collapsed ? "6px" : "8px") : 0,
          color: "text.primary",
          paddingY: logoUrl ? (collapsed ? "10px" : "12px") : "4px",
        }}
        data-branding-size={brandingSize}
      >
        <Box
          sx={{
            height: logoUrl ? (collapsed ? "38px" : "48px") : "52px",
            width: "100%",
            flexShrink: 0,
          }}
        >
          <CryptorsLogo
            height="100%"
            width="100%"
            color={palette.text.primary}
            stroke={palette.text.primary}
            fill={palette.text.primary}
          />
        </Box>
        {logoUrl && (
          <Box
            component="img"
            src={logoUrl}
            alt="Logo client"
            sx={{
              width: "100%",
              maxWidth: collapsed ? "38px" : "120px",
              height: collapsed ? "38px" : "58px",
              flexShrink: 0,
              objectFit: "contain",
            }}
          />
        )}
      </Box>
    </Link>
  );
};
